import { HeaderType } from 'src/components/UI/CustomUI/organisms/Table/types'

const headers: HeaderType[] = [
    { id: 'amountDue', label: 'Amount Due' },
    { id: 'amountPaid', label: 'Amount Paid' },
    { id: 'dueDate', label: 'Due Date' },
    { id: 'status', label: 'Status' },
]

export default headers
